<adapt-two-column-page>
    <div left-column>
        <adapt-dashboard-element [info]="CulturalCohortTooltip"
                                 [name]="cohortName">
            <dx-list *adaptLoadingUntilFirstEmit="let culturalCohort of cohort$"
                     class="dx-list-boxed mb-3"
                     [dataSource]="culturalCohort"
                     selectionMode="single"
                     [focusStateEnabled]="false"
                     [selectedItems]="[selectedCohortMember]"
                     (onSelectionChanged)="onPrimaryListSelectionChanged($event)">
                <div *dxTemplate="let member of 'item'">
                    <ng-container *ngTemplateOutlet="culturalRelationshipPersonTemplate; context: {member: member}"></ng-container>
                </div>
            </dx-list>

            <adapt-collapsible-dashboard-element [info]="SupportingMemberTooltip"
                                                 [collapsed]="hasCohortMembers"
                                                 class="supporting"
                                                 name="Supporting members">
                <dx-list [dataSource]="supportingMembers"
                         [focusStateEnabled]="false"
                         (onInitialized)="supportingMembersList = $event.component"
                         [grouped]="true"
                         [collapsibleGroups]="true"
                         [selectedItems]="[selectedCohortMember]"
                         class="dx-list-boxed"
                         selectionMode="single">
                    <div *dxTemplate="let group of 'group'">
                        <adapt-link-person *ngIf="group.key; else unallocatedGroup"
                                           [personId]="group.key"
                                           [adaptLinkDisabled]="true"></adapt-link-person>
                        <ng-template #unallocatedGroup>
                            <span>(No cultural leader)</span>
                        </ng-template>
                    </div>
                    <div *dxTemplate="let data of 'item'">
                        <ng-container *ngTemplateOutlet="culturalRelationshipPersonTemplate; context: {member: data.member}"></ng-container>
                    </div>
                </dx-list>
            </adapt-collapsible-dashboard-element>
        </adapt-dashboard-element>
    </div>

    <div right-column>
        <adapt-dashboard-element *ngIf="selectedCohortMember"
                                 [name]="selectedCohortMember.relationship.person.fullName">
            <div adapt-dashboard-title-buttons>
                <button *adaptIfAuthorised="EditCareerValuationForPerson;Entity:selectedCohortMember.relationship.person"
                        adaptButton="add"
                        (click)="recordCVT()">Career Valuation</button>
                <button *adaptIfAuthorised="EditCulturalIndexForPerson;Entity:selectedCohortMember.relationship.person"
                        adaptButton="add"
                        (click)="recordCI()">Cultural Index</button>
            </div>

            @if (canReadCVDataForSelectedCohortMember) {
                <div data-test="next-career-valuation-due"
                     class="mb-3">
                    <b>Next Career Valuation Due</b>:
                    {{selectedCohortMember.nextCVT ? (selectedCohortMember.nextCVT | adaptDate) : "never"}}
                    <ng-container *ngIf="selectedCohortMember.nextCVTActivity as activity">
                        <adapt-activity-rescheduled-info *ngIf="activity.extensions.hasRescheduled"
                                                         [activity]="activity"></adapt-activity-rescheduled-info>
                        <div>
                            <button class="btn btn-link"
                                    (click)="rescheduleEvent(activity)">Reschedule Career Valuation</button>
                        </div>
                    </ng-container>
                </div>
                <div data-test="career-valuation">
                    <ng-container *ngIf="selectedCohortMember.nextCVT; else NoCvtRecordedTemplate">
                        <adapt-cvt-history [personId]="selectedCohortMember.relationship.personId"
                                           [showGrid]="false"></adapt-cvt-history>
                    </ng-container>
                </div>

                @if (canReadCIDataForSelectedCohortMember) {
                    <!-- separator only if both show -->
                    <hr />
                }
            }

            @if (canReadCIDataForSelectedCohortMember) {
                <div data-test="next-cultural-index-due"
                     class="mb-3"><b>Next Cultural Index Due</b>:
                    {{selectedCohortMember.nextCI ? (selectedCohortMember.nextCI | adaptDate) : "never"}}
                    <ng-container *ngIf="selectedCohortMember.nextCIActivity as activity">
                        <adapt-activity-rescheduled-info *ngIf="activity.extensions.hasRescheduled"
                                                         [activity]="activity"></adapt-activity-rescheduled-info>
                        <div>
                            <button class="btn btn-link"
                                    (click)="rescheduleEvent(activity)">Reschedule Cultural Index</button>
                        </div>
                    </ng-container>
                </div>
                <div data-test="cultural-index">
                    <ng-container *ngIf="selectedCohortMember.nextCI; else NoCiRecordedTemplate">
                        <adapt-ci-history [personId]="selectedCohortMember.relationship.personId"
                                          [showGrid]="false"></adapt-ci-history>
                    </ng-container>
                </div>
            }

            <ng-template #NoCvtRecordedTemplate>No Career Valuation has been recorded</ng-template>
            <ng-template #NoCiRecordedTemplate>No Cultural Index has been recorded</ng-template>
        </adapt-dashboard-element>
    </div>

    <ng-template #culturalRelationshipPersonTemplate
                 let-member="member">
        <div (click)="onSelectionChanged(member)"
             class="d-flex flex-row gap-3 align-items-center">
            <adapt-link-person *ngIf="member && member.relationship"
                               [personId]="member.relationship.personId"
                               [showImage]="true"
                               [showText]="true"
                               [adaptLinkDisabled]="true"
                               class="flex-grow-1"></adapt-link-person>
            <div class="d-flex flex-column gap-1 align-items-end">
                <span *ngIf="member && member.catchupStatus"
                      class="badge"
                      [ngClass]="member.catchupStatus.badgeClass">{{member.catchupStatus.defaultLabel}}</span>
                <span *ngIf="member && member.nextCatchup">Due: {{member.nextCatchup | adaptDate}}</span>
            </div>
        </div>
    </ng-template>
</adapt-two-column-page>
